import Swiper from 'swiper'
import { Navigation, Autoplay } from 'swiper/modules'

document.addEventListener('DOMContentLoaded', () => {
    let whatSlider = null;

    const mediaQuery = window.matchMedia('(min-width: 1280px)');

    const handleSlider = () => {

        if (mediaQuery.matches) {

            if (!whatSlider) {
                whatSlider = new Swiper('.faq-web-app__question-list-outstaffing', {
                    modules: [Navigation],
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                    slideToClickedSlide: true,
                    loop: true,
                    centeredSlides: true,
                    slidesOffsetBefore: -162,
                    navigation: {
                        nextEl: '.faq-web-app__question-list-outstaffing .tab-next',
                        prevEl: '.faq-web-app__question-list-outstaffing .tab-prev',
                    },
                    breakpoints: {
                        1280: {
                            slidesOffsetBefore: -100,
                        },
                        1438: {
                            slidesOffsetBefore: -162,
                        }
                    }
                });
            }

        } else {

            if (whatSlider) {
                whatSlider.destroy(true, true);
                whatSlider = null;
            }

        }
    };

    handleSlider();

    mediaQuery.addEventListener('change', handleSlider);

    const initTrustSlider = (el, extraOptions = {}) => {
        if (!el) return null;

        return new Swiper(el, {
            modules: [Autoplay],
            slidesPerView: 'auto',
            spaceBetween: 0,
            loop: true,
            speed: 6000,
            allowTouchMove: false,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            ...extraOptions,
        });
    };

    const desktopMq = window.matchMedia('(min-width: 1280px)');

    document.querySelectorAll('.trust-us-slider').forEach((el) => {
        const isResponsive = Boolean(el.closest('.stages-web-app__trust-us--slider'));
        const extraOptions = el.classList.contains('trust-us-slider-2')
            ? { slidesOffsetBefore: 120 }
            : {};

        if (!isResponsive) {
            initTrustSlider(el, extraOptions);
            return;
        }

        let swiper = null;
        const sync = () => {
            if (desktopMq.matches) {
                if (swiper) {
                    swiper.destroy(true, true);
                    swiper = null;
                }
                return;
            }
            if (!swiper) {
                swiper = initTrustSlider(el, extraOptions);
            }
        };

        sync();
        desktopMq.addEventListener('change', sync);
    });
});